import { Talent } from "../../Classes";

const tier7 = [
  null,
  new Talent(
    "Combustion",
    "spell_fire_sealoffire",
    [
      "When activated, this spell causes each of your Fire damage spell hits to increase your critical strike chance with Fire damage spells by 10%. This effect lasts until you have caused 3 critical strikes with Fire spells.",
    ],
    1,
    [[]],
    [{ x: 4, y: 1 }],
    null,
    null,
    null,
    "Instant",
    "3 min cooldown"
  ),
  null,
  null,
];

export default tier7;
